<template>
    <transition name="modal" v-if="isActive">
        <div class="modal-mask">
            <div class="modal-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            {{ $PPlusEngine.getDictionary($route.params.lang, 'ลงทะเบียน', 'Sign Up') }}
                            <button @click="hide()"><font-awesome-icon :icon="['fas', 'times']" /></button>
                        </h4>
                    </div>        
                    <div class="modal-body">
                        <div class="group">
                            <h6>ข้อมูลลงทะเบียน</h6>
                            <div class="form-group">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'อีเมล', 'Email') }}</label>
                                <input type="email" class="form-control" maxlength="100" :class="$PPlusEngine.highlightInvalidField(registerValidate.email.invalid)" v-model="registerForm.email" />
                                <span class="error-message" v-if="registerValidate.email.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกอีเมล', 'Please input email') }}</span>
                                <span class="error-message" v-if="registerValidate.email.format">{{ $PPlusEngine.getDictionary($route.params.lang, 'รูปแบบอีเมลไม่ถูกต้อง', 'Email format is invalid') }}</span>
                            </div>
                            <div class="form-group">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่าน', 'Password') }}</label>
                                <input type="password" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.password.invalid)" v-model="registerForm.password" />
                                <span class="error-message" v-if="registerValidate.password.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกรหัสผ่าน', 'Please input your password') }}</span>
                                <span class="error-message" v-if="registerValidate.password.length">{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร', 'Password requires at least 8 characters') }}</span>
                            </div>
                        </div>
                        <div class="group">
                            <h6>ข้อมูลทั่วไป</h6>
                            <div class="row">
                                <div class="column col-12">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'เลขบัตรประชาชน/พาสปอร์ต', 'Personal ID/Passport') }} <span id="personalIDNote"><font-awesome-icon :icon="['fas', 'question-circle']" /></span><b-tooltip target="personalIDNote">{{ $PPlusEngine.getDictionary($route.params.lang, 'ใช้สำหรับระบุตัวตนกับปปง. หรือหน่วยงานอื่นๆ', 'Use for personal verification with organizations') }}</b-tooltip></label>
                                        <input type="text" class="form-control" maxlength="13" :class="$PPlusEngine.highlightInvalidField(registerValidate.personalId.invalid)" v-model="registerForm.personalId" />
                                        <span class="error-message" v-if="registerValidate.personalId.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไมไ่ด้กรอกเลขบัตรประชาชน', 'Please input your personal id or passport') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="column col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'เบอร์ติดต่อ', 'Phone Number') }}</label>
                                        <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.tel.invalid)" v-model="registerForm.tel" />
                                        <span class="error-message" v-if="registerValidate.tel.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกเบอร์ติดต่อ', 'Please input your phone number') }}</span>
                                    </div>
                                </div>
                                <div class="column col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'วันเกิด', 'Birthdate') }}</label>
                                        <date-picker :input-class="'form-control calendar-input' + ' ' + $PPlusEngine.highlightInvalidField(registerValidate.birthdate.invalid)" calendar-class="calendar-box" v-model="registerForm.birthdate"></date-picker>
                                        <span class="error-message" v-if="registerValidate.birthdate.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกวันเดือนปีเกิด', 'Please input your birthdate') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="column col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อ (ภาษาไทย)', 'First Name (In Thai)') }}</label>
                                        <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.firstNameTH.invalid)" v-model="registerForm.firstNameTH" />
                                        <span class="error-message" v-if="registerValidate.firstNameTH.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกชื่อภาษาไทย', 'Please input your first name') }}</span>
                                    </div>
                                </div>
                                <div class="column col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'นามสกุล (ภาษาไทย)', 'Last Name (In Thai)') }}</label>
                                        <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.lastNameTH.invalid)" v-model="registerForm.lastNameTH" />
                                        <span class="error-message" v-if="registerValidate.lastNameTH.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกนามสกุลภาษาไทย', 'Please input your last name') }}</span>
                                    </div>
                                </div>

                                <div class="column col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อ (ภาษาอังกฤษ)', 'First Name (In English)') }}</label>
                                        <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.firstNameEN.invalid)" v-model="registerForm.firstNameEN" />
                                        <span class="error-message" v-if="registerValidate.firstNameEN.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกชื่อภาษาอังกฤษ', 'Please input your first name') }}</span>
                                    </div>
                                </div>
                                <div class="column col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'นามสกุล (ภาษาอังกฤษ)', 'Last Name (In English)') }}</label>
                                        <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.lastNameEN.invalid)" v-model="registerForm.lastNameEN" />
                                        <span class="error-message" v-if="registerValidate.lastNameEN.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกนามสกุลภาษาอังกฤษ', 'Please input your last name') }}</span>
                                    </div>
                                </div>

                                <div class="column col-12">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'อาชีพปัจจุบัน', 'Occupation') }}</label>
                                        <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.occupation.invalid)" v-model="registerForm.occupation" />
                                        <span class="error-message" v-if="registerValidate.occupation.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกอาชีพปัจจุบัน', 'Please input your occupation') }}</span>
                                    </div>
                                </div>
                                <div class="column col-12">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อองค์กร/สถาบันที่สังกัด', 'Working for Company') }} <span id="companyNote"><font-awesome-icon :icon="['fas', 'question-circle']" /></span><b-tooltip target="companyNote">{{ $PPlusEngine.getDictionary($route.params.lang, 'ถ้าไม่มีกรุณาระบุ "-"', 'If none, please input "-"') }}</b-tooltip></label>
                                        <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(registerValidate.company.invalid)" v-model="registerForm.company" />
                                        <span class="error-message" v-if="registerValidate.company.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกชื่อองค์กร/สถาบันที่สังกัด', 'Please input company you are working for') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="error-message" v-if="registerValidate.form.invalid">{{ registerValidate.form.message }}</span>
                        <AcceptPDPA @updateAcceptance="updateAcceptance($event)"></AcceptPDPA>
                        <div class="action">
                            <button class="btn btn-main btn-block" :class="{ 'blocked': !registerForm.isAccept }" @click="submitRegister()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ลงทะเบียน', 'Sign Up') }}</button>
                        </div>
                        <section class="group-link">
                            <div class="wrapper">
                                <button class="link" @click="showLogin()">{{ $PPlusEngine.getDictionary($route.params.lang, 'เข้าสู่ระบบ', 'Sign In') }}</button>
                            </div>
                            <div class="wrapper">
                                <span class="link">|</span>
                            </div>
                            <div class="wrapper">
                                <button class="link" @click="showForgetPassword()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ลืมรหัสผ่าน', 'Forget Password') }}</button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import PPlusModal from '@/resources/PPlusModal.js';
import PPlusNotify from '@/resources/PPlusNotify';
import AcceptPDPA from '@/components/AcceptPDPA';

export default {
    mixins: [PPlusNotify],
    components: { AcceptPDPA },
    props: {
        fields: Object
    },
    data() {
        return {
            isActive: false,
            registerForm: this.initModelRegister(),
            registerValidate: this.initValidateRegister()
        }
    },
    watch: {
        isActive(curr) {
            if (curr) {
                this.$WeHelper.modalScrollable(true);
            }
            else {
                this.$WeHelper.modalScrollable(false);
            }
        }
    },
    methods: {
        show() {
            this.isActive = true;
        },
        hide() {
            this.isActive = false;
        },
        initModelRegister() {
            return { email: '', password: '', personalId: '', tel: '', birthdate: '', firstNameTH: '', lastNameTH: '', firstNameEN: '', lastNameEN: '', occupation: '', company: '', langCode: this.$route.params.lang, isAccept: false };
        },
        initValidateRegister() {
            return { 
                email: { invalid: false, blank: false, format: false }, 
                password: { invalid: false, blank: false, length: false },
                personalId: { invalid: false, blank: false },
                tel: { invalid: false, blank: false },
                birthdate: { invalid: false, blank: false },
                firstNameTH: { invalid: false, blank: false },
                lastNameTH: { invalid: false, blank: false },
                firstNameEN: { invalid: false, blank: false },
                lastNameEN: { invalid: false, blank: false },
                occupation: { invalid: false, blank: false },
                company: { invalid: false, blank: false },
                form: { invalid: false, message: '' }
            }
        },
        showLogin() {
            let page = this;
            page.hide();
            
            setTimeout(function(){
                page.$PPlusModal.login();
            }, 0);
        },
        showForgetPassword() {
            let page = this;
            page.hide();
            
            setTimeout(function(){
                page.$PPlusModal.forgetPassword();
            }, 0);
        },
        updateAcceptance(value) {
            this.registerForm.isAccept = value;
        },
        submitRegister() {
            if (this.registerForm.isAccept) {
                this.registerValidate = this.initValidateRegister();

                if (!this.validateField()) {
                    let loader = this.$WeHelper.modalLoad();
                    let apiURL = this.$PPlusConfig.ApiURL;

                    this.$recaptcha('register').then((token) => {
                        this.registerForm.recaptcha = token;

                        this.$WeHelper.postAPI(apiURL, '/api/user/register', this.registerForm).then((response) => {
                            if (!this.$WeHelper.isNullOrEmpty(response.data)) {
                                if (response.data.isAuthen) {
                                    this.$cookie.set('token', response.data.token, { expires: 7 });
                                    location.reload();
                                }
                                else {
                                    loader.hide();
                                    this.registerValidate.form.invalid = true;
                                    this.registerValidate.form.message = response.data.message;
                                }
                            }
                            else {
                                loader.hide();
                                this.alertSystemError();
                            }
                        });
                    });
                }
            }
        },
        validateField() {
            var isError = false;

            if (!this.registerForm.email) {
                this.registerValidate.email.invalid = true;
                this.registerValidate.email.blank = true;
                isError = true;
            }
            if (!this.$WeHelper.validateEmail(this.registerForm.email)) {
                this.registerValidate.email.invalid = true;
                this.registerValidate.email.format = true;
                isError = true;
            }
            if (!this.registerForm.password) {
                this.registerValidate.password.invalid = true;
                this.registerValidate.password.blank = true;
                isError = true;
            }
            if (!this.registerForm.personalId) {
                this.registerValidate.personalId.invalid = true;
                this.registerValidate.personalId.blank = true;
                isError = true;
            }
            if (!this.registerForm.tel) {
                this.registerValidate.tel.invalid = true;
                this.registerValidate.tel.blank = true;
                isError = true;
            }
            if (!this.registerForm.birthdate) {
                this.registerValidate.birthdate.invalid = true;
                this.registerValidate.birthdate.blank = true;
                isError = true;
            }
            if (this.registerForm.password && this.registerForm.password.length < 8) {
                this.registerValidate.password.invalid = true;
                this.registerValidate.password.length = true;
                isError = true;
            }
            if (!this.registerForm.firstNameTH) {
                this.registerValidate.firstNameTH.invalid = true;
                this.registerValidate.firstNameTH.blank = true;
                isError = true;
            }
            if (!this.registerForm.lastNameTH) {
                this.registerValidate.lastNameTH.invalid = true;
                this.registerValidate.lastNameTH.blank = true;
                isError = true;
            }
            if (!this.registerForm.firstNameEN) {
                this.registerValidate.firstNameEN.invalid = true;
                this.registerValidate.firstNameEN.blank = true;
                isError = true;
            }
            if (!this.registerForm.lastNameEN) {
                this.registerValidate.lastNameEN.invalid = true;
                this.registerValidate.lastNameEN.blank = true;
                isError = true;
            }
            if (!this.registerForm.occupation) {
                this.registerValidate.occupation.invalid = true;
                this.registerValidate.occupation.blank = true;
                isError = true;
            }
            if (!this.registerForm.company) {
                this.registerValidate.company.invalid = true;
                this.registerValidate.company.blank = true;
                isError = true;
            }

            return isError;
        }
    },
    beforeMount() {
        PPlusModal.EventBus.$on('showRegister', () => {
            this.show();
        });
    }
}
</script>